<template>
  <v-container fluid fill-height class="contact-form-scroll">

  <!-- <v-layout column> -->
    <v-toolbar dense ref="aToolbar" flat>
      <v-toolbar-title>
        {{ $t('RESULTS_NUM_SELECTED', [`${numSelected} / ${contactsTotal}`]) }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text :disabled="!contactItems.length || numSelected >= 2" @click="gotoContactForm()" color="primary" :title="$t('RESULTS_OPEN_CONTACT_CM')">{{ $t('RESULTS_NAVI_OPEN') }}</v-btn>
        <v-btn text v-if="contactItems.length && !numSelected" @click="onDelete()" color="red darken-1" :title="$t('RESULTS_DELETE_CONTACT_CM')">{{ $t('RESULTS_NAVI_DELETE') }}</v-btn>
        <v-btn text v-if="numSelected" @click="onDelete()" color="red darken-1" :title="$t('RESULTS_DEL_MARKED_CONTACTS_CM')">{{ $t('RESULTS_NAVI_DELETE') }}</v-btn>
        <v-btn text v-if="numSelected" @click="onEdit()" :title="$t('RESULTS_EDIT_MARKED_CONTACTS_CM')">{{ $t('RESULTS_NAVI_EDIT') }}</v-btn>
        <v-btn text v-if="numSelected" @click="onExport()" :title="$t('RESULTS_EXPORT_MARKED_CONTACTS_CM')">{{ $t('RESULTS_NAVI_EXPORT') }}</v-btn>
        <v-btn text v-if="numSelected" @click="onNewGroup()" :title="$t('RESULTS_CREATE_NEW_CONTACTGROUP_CM')">{{ $t('RESULTS_NAVI_GROUP') }}</v-btn>
        <v-btn text v-if="numSelected >= 2" @click="onMerge()" :title="$t('RESULTS_MERGE_MARKED_CONTACTS_CM')">{{ $t('RESULTS_NAVI_MERGE') }}</v-btn>
        <v-divider inset vertical></v-divider>
        <v-btn text to="/contact/settings">{{ $t('RESULTS_SETTINGS') }}</v-btn>
        <v-btn text icon @click="reloadSearch()"><v-icon>mdi-refresh</v-icon></v-btn>
        <v-btn v-if="isDebug" fab small color="grey lighten-3" class="btn-debug" @click="debug=!debug"><v-icon>mdi-bug-outline</v-icon></v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <!-- <v-container fluid fill-height>
      <v-card width="100vw">
        <v-data-table
          :headers="headers"
          :items="desserts"
          :items-per-page="5"
          class="elevation-1"
        />
      </v-card>
    </v-container> -->
    <v-layout child-flex>
    <v-card width="100vw" height="100vw">
    <!-- <v-sheet> -->
      <v-data-table
        dense
        fixed-header
        :headers="headers"
        :items="contactItems"
        :items-per-page="itemsPerPage"
        class="elevation-1 contactlist"
        :options.sync="options"
        :loading="isLoading"
        show-select
        @click:row="onActive"
        @dblclick:row="gotoContactForm"
        :footer-props="footerProps"
        :server-items-length="contactsTotal"
        :custom-sort="customSort"
        :search="filterSearch"
        :custom-filter="filterContacts"
      >

        <!-- ---- SLOT: TOP ---- -->
        <template v-slot:top="props">
          <div class="top_title">{{ gridTitle[0] }} &nbsp; <b> {{ gridTitle[1] }} </b> &nbsp; {{ gridTitle[2] }}</div>
          <v-row>
            <v-col>
              <v-data-footer
                :pagination="props.pagination"
                :options="props.options"
                @update:options="props.updateOptions"
                :items-per-page-options="footerProps.itemsPerPageOptions"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
                show-first-last-page
              />
            </v-col>
          </v-row>
        </template>

        <!-- ---- SLOT: Item: Fields ---- -->
        <template v-slot:[`item.bounced`]="{ item }">
          <v-icon>{{ item.bounced ? 'mdi-check-circle-outline' : 'mdi-circle-outline' }}</v-icon>
        </template>
        <template v-slot:[`item.newsletter`]="{ item }">
          <v-icon>{{ item.newsletter ? 'mdi-check-circle-outline' : 'mdi-circle-outline' }}</v-icon>
        </template>

        <!-- ---- SLOT: Item ---- -->
        <template v-slot:[`header.data-table-select`]="{ on, props }">
          <v-checkbox
            color="purple"
            v-bind="props"
            v-on="on"
            v-model="checkAllToExport"
            primary
            hide-details
            @click.native="toggleAll"
          ></v-checkbox>
        </template>
        <!-- style="user-select: none;" -->
        <template v-slot:item="props">
          <tr
            :key="props.index"
            :active="props.isSelected"

            :data-index="props.index"
            :class="activeIndex==props.index ? 'active' : ''"
            tabindex="-1"
            @click="onActive(props.index)"
            @dblclick="gotoContactForm()"
            @keyup.up="onActive(props.index-1)"
            @keyup.down="onActive(props.index+1)"
            @keypress.space.prevent="checkItem(props.item)"
            @keyup.13="gotoContactForm()"
            >
            <td>
              <v-sheet v-if="debug">{{ props.item.id }}</v-sheet>
              <v-checkbox
                :input-value="isItemSelected(props.item)"
                @change="checkItem(props.item)"
                primary
                hide-details
              ></v-checkbox>
            </td>
            <template v-for="column in visibleFields">
              <td :key="column.id" class="text-xs">
                <v-icon v-if="column.datatype==='checkbox'">{{ props.item[column.field] ? 'mdi-check-circle-outline' : 'mdi-circle-outline' }}</v-icon>
                <span v-else-if="column.datatype==='free'">{{ props.item['customFields'][column.id] }}</span>
                <span v-else-if="column.id==='gender'">{{ gender[props.item[column.field]] }}</span>
                <span v-else>{{ props.item[column.field] }}</span>
              </td>
            </template>
          </tr>
        </template>
      </v-data-table>
    <!-- </v-sheet> -->

    </v-card>
    </v-layout>
    <Dialog ref="dialog" />

    <ContactExportDlg
      v-if="exportDlg"
      :visible="exportDlg"
      @cancel="exportDlg=false"
    />
    </v-container>

  <!-- </v-layout> -->
</template>

<script>
import convert from 'xml-js'
// import xor from 'array-xor'
import { mapGetters } from 'vuex'

// import EventBus from '../event-bus'
import Contact from '../services/Contact'

import Dialog from './common/Dialog'
import ContactExportDlg from './ContactExportDlg'
import { SearchModel } from '../models/SearchModel'
import Search from '../services/Search'
import Selection from '../services/Selection'

export default {
  name: 'ContactList',
  components: {
    Dialog,
    ContactExportDlg,
  },
  props: ['search_id', 'title', 'type', 'simple_search', 'refToolbar',],
  data() {
    return {
      debug: false,
      isUnsaved: null,
      activeIndex: 0,
      totalContacts: 0,
      options: {},
      f_inProgress: false,
      exportDlg: false,
      searchType: 'extended',
      searchVal: null,
      isLoading: false,
      itemsPerPage: 100,
      footerProps: {
        showFirstLastPage: true,
        itemsPerPageOptions: [100, 50, 30, 20, 10],
      },
      filterSearch: '',
      selectedOnly: false,
    }
  },
  computed: {
    ...mapGetters([
      'isDebug', 'data', 'settings', 'contactItems', 'contactsTotal', 'searchesSortBy', 'searchesSortDesc',
      'isUnsavedXml', 'mSearch', 'activeContact', 'searchReq', 'exportIds', 'selectedItems', 'allToExport',
      'contactPage', 'contactItemsPerPage', 'user', 'searchDirty'
      ]),
    gridTitle() {
      const titles = []
      const routeName = this.$route.name
      if (routeName == 'contact.simple_search') {
        titles[0] = this.$t('RESULTS_SIMPLE_SEARCH_FOR')
        titles[1] = this.simple_search
        titles[2] = this.$t('RESULTS_IN_SEARCH_FIELDS')
      } else if (routeName == 'contact.extended_search') {
        titles[0] = this.$t('EXTSEARCH_TITLE') +':    '
        titles[1] = this.title
      } else if (routeName == 'contact.search_all') {
        titles[0] = this.$t('RESULTS_ALL_CONTACTS')
      } else if (routeName == 'contact.group') {
        titles[0] = this.$t('EXTSEARCH_TITLE_GROUP') +':    '
        titles[1] = this.title
      }
      return titles
    },
    checkAllToExport: {
      get () {
        return this.allToExport
      },
      set (val) {
        this.$store.commit('setAllToExport', val)
      }
    },
    visibleFields() {
      const allFields = this.data.fields.concat(this.data.custom_fields.map(a => ({ ...a, field: `FF_${a.id}` })))
      const visibleFields = this.settings.user.visible_columns.column.map(a => allFields.find(b => b.field === a)).filter(Boolean)
      return visibleFields
    },
    headers() {
      return this.visibleFields.map(a => ({
        text: a.type === 'free' ? a.label : this.$t(`DB_${a.field.toUpperCase()}`),
        value: a.field,
        sortable: a.type === 'free' ? false : a.sortable,
        editable: a.type === 'free' ? false : a.editable,
        sort: a.id
      }))
    },
    numSelected() {
      if (this.checkAllToExport) {
        return this.contactsTotal - this.exportIds.length
      } else {
        return this.exportIds.length
      }
    },
    gender() {
      return {
        // '0': this.$t('CONTACT_GENDER_UNKNOWN'),
        '0': '',
        '1': this.$t('CONTACT_GENDER_MALE'),
        '2': this.$t('CONTACT_GENDER_FEMALE'),
      }
    },
  },

// --------------------------------- MOUNTED --------------------------------

  mounted() {
    this.refToolbar.$el.parentElement.appendChild(this.$refs.aToolbar.$el)
    this.$store.commit('setContactItems', [])

    this.options.sortBy = this.searchesSortBy
    this.options.sortDesc = this.searchesSortDesc

    this.options.page = this.contactPage; //:PETAR current page number 
    this.options.itemsPerPage = this.user.results_per_page ? this.user.results_per_page : (parseInt(this.settings.user.results_per_page) || 100);
    // this.reloadSearch()
  },

// --------------------------------- WATCH --------------------------------

  watch: {
    checkAllToExport(checked) {
      this.toggleAll(checked)
    },
    activeIndex(index) {
      this.focusTR(index)
    },
    contactItems(items) {
      if (items.length) {
        this.f_inProgress = true
        this.$nextTick(() => {
          this.focusTR(0)
          this.onActive(null, {index:0})
          this.f_inProgress = false
        })
      }
    },
    options: {
      handler () {
        this.getDataFromApi()
      },
      deep: true,
    },
    'options.sortBy'(val) {
      this.$store.commit('setSearchesSortBy', val)
    },
    'options.sortDesc'(val) {
      this.$store.commit('setSearchesSortDesc', val)
    },
    search_id(val) {
      this.w__search(val)
    },
    simple_search(val) {
      this.w__search(val)
    },
    'options.page'(val) {
      this.$store.commit('setContactPage', val);
    },
    'options.itemsPerPage'(val) {
      this.$store.commit('setUserItemPerPage', val);
    },
  },

// ********** BEGIN ****************** METHODS ********************************

  methods: {

    focusTR(index){
      let selected = document.querySelector('[data-index="'+index+'"]')
      if (selected) {
        selected.focus()
      }
    },
    customSort(items){
          // (items: any[], sortBy: string[], sortDesc: boolean[], locale: string, customSorters?: Record<string, compareFn>) => any[]
      // console.log ('customSort:', items, sortBy, sortDesc, locale, customSorters)
      return items
    },

//  ********* Begin SEARCH *******************

    getDataFromApi () {
      this.loading = true
      this.reloadSearch().then(() => {
        this.loading = false
      })
    },

    reloadSearch(force=true) {
      const routeName = this.$route.name
      if (force || this.contactItems.length) {
        if (force) {
          // unselect all items
          if (routeName == 'contact.simple_search') {
            if ( this.searchReq.type != 'simple' || this.searchReq.val != this.simple_search) {
              this.uncheckAll()
              this.$store.commit('setSearchReq', {type: 'simple', val: this.simple_search})
              this.options.page = 1;
            }
          } else if (routeName == 'contact.extended_search') {
            if (this.searchReq.val != this.search_id || this.searchDirty) {
              if (this.searchDirty){
                // EXDEVBG-195 - In case extended search is modified 
                this.$store.commit('setSearchDirty', false) 
              }
              this.uncheckAll()
              this.$store.commit('setSearchReq', {type: 'extended', val: this.search_id})
              this.options.page = 1;
            }
          } else if (routeName == 'contact.search_all') {
            if ( this.searchReq.val != 'all') {
            // if (this.searchReq.val != this.search_id) {
              this.uncheckAll()
              this.$store.commit('setMSearch', new SearchModel(true, true))
              this.$store.commit('setSearchReq', {type: 'extended', val: 'all'})
              this.options.page = 1;
            }
          } else if (routeName == 'contact.group') {
            if (this.searchReq.val != this.search_id) {
              this.uncheckAll()
              this.$store.commit('setSearchReq', {type: 'extended', val: this.search_id})
              this.options.page = 1;
            }
          }
        } else {
          this.options.page = 1
        }
        let sort = 'name asc'
        if (this.options.sortBy.length) {
          const sortBy = this.headers.find(h => h.value == this.options.sortBy[0]).sort // important! - get dbsort name instead of value name
          sort = sortBy+' '+(this.options.sortDesc[0]?'desc':'asc')
        }
        if (routeName == 'contact.simple_search') {
          return new Search(this.$api).simple_search({search_string: this.simple_search, sort: sort, page: this.options.page - 1, rows: this.options.itemsPerPage})
        } else if (routeName == 'contact.extended_search') {
          // after page reload - missing mSearch so switch to search view
          if (this.search_id > 0 || this.search_id == 'new' || !this.isUnsavedXml) {
            if (this.isUnsavedXml && (!this.mSearch.blocks.length || !this.mSearch.isValid())) {
              if (!this.mSearch.isValid()) {
                this.$store.commit('showMessage', {color: 'orange', title: this.$t('EXTSEARCH_INVALID_TITLE'), content: this.$t('EXTSEARCH_INVALID') + ' ' + this.$t('EXTSEARCH_INVALID_FIELD')})
              }
              this.$router.push({ name: 'search', params: { id: 'new' }, hash: this.getNewHash()})
            } else {
              return new Search(this.$api).extended_search({search_id: this.search_id, isUnsavedXml: this.isUnsavedXml, sort: sort, page: this.options.page - 1, rows: this.options.itemsPerPage})
            }
          }
        } else if (routeName == 'contact.search_all') {
          return new Search(this.$api).search_all({sort: sort, page: this.options.page - 1, rows: this.options.itemsPerPage})
        } else if (routeName == 'contact.group') {
          return new Search(this.$api).extended_search({search_id: this.search_id, isUnsavedXml: this.isUnsavedXml, sort: sort, page: this.options.page - 1, rows: this.options.itemsPerPage})
        }
      }
      return new Promise((resolve) => {
        resolve (this.contactItems)
      })
    },

//  ************* Search from WATCHERS *******************

    w__search(val) {
      if (val) {
        // reset PAGE=0 due to requirement on every request to move to page.0
        this.options.page = 1
        this.$store.commit('setMSearch', new SearchModel())
        this.$store.commit('setIsUnsavedXml', false)
        this.mode = 'list'
        this.reloadSearch()
      }
    },

//  ********* END SEARCH *******************

    uncheckAll() {
      this.checkAllToExport = false
      this.exportIds.splice(0, this.exportIds.length)
      this.selectedItems.splice(0, this.selectedItems.length)
    },
    toggleAll(checked) {
      if (checked) {
        this.exportIds.splice(0, this.exportIds.length)
        this.selectedItems.splice(0, this.selectedItems.length)
      }
    },
    isItemSelected(item) {
      const isSelected = this.checkAllToExport && !this.exportIds.includes(item.id) || !this.checkAllToExport && this.exportIds.includes(item.id)
      return isSelected
    },
    checkItem(item) {
      const isSelected = !this.isItemSelected(item)
      if (this.checkAllToExport) {
        if (isSelected) {
          // OUT
          this.exportIds.splice(this.exportIds.indexOf(item.id), 1)
        } else {
          //  IN
          this.exportIds.push(item.id)
        }
      } else {
        if (isSelected) {
          // IN
          this.exportIds.push(item.id)
        } else {
          // OUT
          this.exportIds.splice(this.exportIds.indexOf(item.id), 1)
        }
      }
      if (isSelected) {
        this.selectedItems.push(item)
      } else {
        this.selectedItems.splice(this.selectedItems.findIndex(a => a.id == item.id), 1)
      }
    },

    renderTitle(header) {
      if (!header.editable && !header.sortable) {
        return this.$t('RESULTS_COLUMN_NO_EDIT_NO_SORT_TT')
      } else if (!header.editable) {
        return this.$t('RESULTS_COLUMN_NO_EDIT_TT')
      } else if (!header.sortable) {
        return this.$t('RESULTS_COLUMN_NO_SORT_TT')
      }
    },

    gotoContactForm() {
      const contact_name = this.activeContact.firstname+' '+this.activeContact.lastname
      this.$router.push({ name: 'contact.edit', params: { contact_id: this.activeContact.id, title: contact_name}, hash: this.getNewHash()})
    },
    onDelete() {
      if (this.numSelected) {
        const self = this;
        this.$refs.dialog.show({
          type: '',
          title: this.$t('GENERIC_DELETE_ALERT_TITLE'),
          message: this.$t('RESULTS_CONFIRM_MULTI_DELETE', [this.numSelected]),
          query: {
            deleteAccounts: {
              type: 'checkbox',
              label: this.$t('CONTACT_DELETE_ACCOUNTS'),
            }
          },
          buttons: [
            {
              label: this.$t('GENERIC_DELETE'),
              close: true,
              danger: true,
              callback: res => {
                const jsonObject = {
                  request: {
                    selection: {
                      _attributes: {
                        type: 'list'
                      },
                    }
                  }
                }
                if (self.checkAllToExport) {
                  if (self.search_id === 'new') {
                    jsonObject.request.selection.query = new Search().buildSearchBlockToJS()
                  } else {
                    jsonObject.request.selection.query = {
                      _attributes: {
                        id: self.search_id
                      }
                    }
                  }
                  jsonObject.request.selection.exclude = {
                    aitem: []
                  }
                    self.exportIds.forEach(a => {
                    jsonObject.request.selection.exclude.aitem.push({
                      _attributes: {
                        id: a
                      }
                    })
                  });
                } else {
                  jsonObject.request.selection.include = {
                    aitem: []
                  }
                    self.exportIds.forEach(a => {
                    jsonObject.request.selection.include.aitem.push({
                      _attributes: {
                        id: a
                      }
                    })
                  });
                }
                const xml = convert.json2xml(jsonObject, {compact: true})
                new Selection(self.$api).delete(xml, res.deleteAccounts.value).then(() => {
                  self.reloadSearch(false);
                })
              },
            },
            {
              label: this.$t('GENERIC_CANCEL'),
              close: true,
            },
          ]
        })
      } else {
        this.$refs.dialog.show({
          type: '',
          title: this.$t('GENERIC_DELETE_ALERT_TITLE'),
          message: this.$t('CONTACT_DELETE_ALERT'),
          query: {
            deleteAccounts: {
              type: 'checkbox',
              label: this.$t('CONTACT_DELETE_ACCOUNTS'),
            }
          },
          buttons: [
            {
              label: this.$t('GENERIC_DELETE'),
              close: true,
              danger: true,
              callback: res => {
                new Contact(this.$api).delete(this.activeContact.id, res.deleteAccounts.value)
              },
            },
            {
              label: this.$t('GENERIC_CANCEL'),
              close: true,
            },
          ]
        })
      }
    },
    onNewGroup() {
      if(this.checkAllToExport) {
        this.$store.commit('showMessage', {color: 'yellow', title: this.$t('RESULTS_CONTACTGROUP_PANEL_TITLE'), content: 'You can not create a group with all sellected contacts!'})
      } else {
        this.$router.push({ name: 'group', params: { group_id: 'new' }, hash: this.getNewHash()})
      }
    },
    onEdit() {
      this.$router.push({
        name: 'contact.mass_edit',
        params: this.checkAllToExport
          ? {ids: this.exportIds.length ? this.exportIds.join(',') : 0, search_id: `${this.search_id}-${this.contactsTotal}`}
          : {ids: this.exportIds.length ? this.exportIds.join(',') : 0}
        , hash: this.getNewHash()})
    },
    onExport() {
      this.exportDlg = true
    },
    onMerge() {
       if(this.checkAllToExport) {
        this.$store.commit('showMessage', {color: 'yellow', title: 'Merge ALL contacts', content: 'You can not merge ALL contacts!'})
      } else {
      this.$router.push({
        name: 'contact.merge',
        params: this.checkAllToExport
          ? {ids: this.exportIds.length ? this.exportIds.join(',') : 0, search_id: `${this.search_id}-${this.contactsTotal}`}
          : {ids: this.exportIds.length ? this.exportIds.join(',') : 0}
        , hash: this.getNewHash()})
      }
    },
    onActive(index) {
      if (index !== null && index >= 0 && index <= this.contactItems.length - 1) {
        this.activeIndex = index
        this.updateActiveContact()
      }
    },
    updateActiveContact() {
      let activeContact = this.contactItems[this.activeIndex]
      this.$store.commit('setActiveContact', activeContact)
    },
    getNewHash() {
      const dt = new Date()
      return '##'+ (dt.getTime()*1000 + dt.getMilliseconds())
    },
    checkSelectedOnly () {
      this.selectedOnly = !this.selectedOnly
    },
    filterContacts (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search) !== -1
    },

    filterContacts2 (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },

// ********** END ****************** METHODS ********************************

  beforeDestroy() {
    this.$refs.aToolbar.$el.remove()
  },
}
</script>

<style scoped lang="scss">
table.v-table tbody td,
table.v-table tbody th {
  height: 3em;
}
.v-datatable thead th.column.sortable .v-icon.title {
  opacity: 1;
}
.v-datatable thead th.column.sortable.active.desc .v-icon.title {
    transform: rotate(0);
}
.theme--light.v-table tbody tr.active:not(.v-datatable__expand-row) {
    background: #eee;
}

.v-input--selection-controls__input input[role=checkbox] .active {
  background: pink;
}

.top_title {
  margin-left: 20px;
}
.top_filter {
  margin-left: 17px;
}

.contact-form-scroll {
  overflow-y: hidden;
}

</style>

<style>
  .contactlist > .v-data-table__wrapper{height:calc(100vh - 280px) !important;}
</style>